import {Component} from '@angular/core';
import { UrlService } from '../../services/url.service';
import {ResidentService} from '../../services/resident.service';


declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'no-buildings-modal',
    templateUrl: './no-buildings-modal.component.html',
    styleUrls: ['./no-buildings-modal.component.scss']
})
export class NoBuildingsModalComponent {

    constructor(
        public urlService: UrlService,
        public residentService: ResidentService
    ) {}

    hideModal() {
        this.residentService.showNoBuildingsModal = false;
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/no-buildings-modal/no-buildings-modal.component.ts